import ReactDOM from "react-dom/client";
import { ThemeProvider, createTheme } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

// Pages
import Login from "./views/pages/Login";
import Home from "./views/pages/Home";

// จัดซื้อสินค้า
import PurchaseOrder from "./views/pages/Purchase/PurchaseOrder";
import ProductReceipt from "./views/pages/Purchase/ProductReceipt";
import PaymentVoucher from "./views/pages/Purchase/PaymentVoucher";
import Tax from "./views/pages/Account/Tax";

// คลังสินค้า
import WarehouseStock from "./views/pages/Warehouse/WarehouseStock";
import Warehouse from "./views/pages/Warehouse/Warehouse";
import WarehouseItem from "./views/pages/Warehouse/WarehouseItem";
import TreasuryDocuments from "./views/pages/Warehouse/TreasuryDocuments";
import WithdrawApprovalPage from "./views/pages/Warehouse/WithdrawApprovalPage";

// Stock pages (ported from D:\Food)
import StockOverviewPage from "./views/pages/Stock/StockOverviewPage";
import StockDocumentsPage from "./views/pages/Stock/StockDocumentsPage";
import StockManagementPage from "./views/pages/Stock/StockManagementPage";
import StockDetailPage from "./views/pages/Stock/StockDetailPage";
import StockFormAdjustPage from "./views/pages/Stock/StockFormAdjustPage";
import StockFormTransferPage from "./views/pages/Stock/StockFormTransferPage";
import StockFormCountPage from "./views/pages/Stock/StockFormCountPage";

import '@fontsource/open-sans'; // default 400
import '@fontsource/open-sans/700.css'; // น้ำหนักตัวหนา


//ระบบขาย
import Sale from "./views/pages/Sale/index";
import EditCustomer from "./views/pages/Sale/EditCustomer";
import History from "./views/pages/Sale/History";
import Quote from "./views/pages/Sale/QuotePage";
import QuoteList from "./views/pages/Sale/QuoteListPage";
import AdminQuoteList from "./views/pages/Sale/AdminQuoteListPage";
import AdminQuote from "./views/pages/Sale/AdminQuotePage";
import './index.css';
import "leaflet/dist/leaflet.css";
import "./utils/fix-leaflet-icon";
import SaleCallReport from "./views/pages/Sale/SaleCallReport";
import SaleCallDetail from "./views/pages/Sale/SaleCallDetail";
import SaleAppointReport from "./views/pages/Sale/SaleAppointReport";
import SaleAppointDetail from "./views/pages/Sale/SaleAppointDetail";
import SaleReport from "./views/pages/Sale/SaleCustomerReportTabs";
import SaleCustomerCalendar from "./views/pages/Sale/SaleCustomerCalendar";


//สัญญา
import ContractList from "./views/pages/Sale/ContractList";
import Contract from "./views/pages/Sale/ContractPage";
import ContractSignPage from "./views/pages/Sale/ContractSignPage";

//งานช่าง
import JobFilePage from "./views/pages/JobFile/JobFilePage";
import JobFileDetailPage from "./views/pages/JobFile/JobFileDetailPage";
import JobFileInvoicePage from "./views/pages/JobFile/JobFileInvoicePage";
import JobFileInvoiceRecordPage from "./views/pages/JobFile/JobFileInvoiceRecordPage";
import JobFileInvoiceRecordListPage from "./views/pages/JobFile/JobFileInvoiceRecordListPage";
import TempEquipmentListPage from "./views/pages/JobFile/TempEquipmentListPage";
import JobFileJobsPage from "./views/pages/JobFile/JobFileJobsPage";
import JobManagementPage from "./views/pages/JobFile/JobManagementPage";
import JobCalendarPageStandalone from "./views/pages/JobFile/JobCalendarPageStandalone";
import JobListPage from "./views/pages/JobFile/JobListPage";
import JobServiceClosePage from "./views/pages/JobFile/JobServiceClosePage";
import FeedbackPage from "./views/pages/Feedback/FeedbackPage";



// ข้อมูลตั้งต้น
import Employee from "./views/pages/InitialData/Employee";
import Team from "./views/pages/InitialData/Team";
import TbSetItem from "./views/pages/InitialData/TbSetItem";
import Company from "./views/pages/InitialData/Company";
import OrgAccessAdminPage from "./views/pages/InitialData/OrgAccessAdminPage";
import TbSetTransType from "./views/pages/InitialData/TbSetTransType";
import TbSetDocType from "./views/pages/InitialData/TbSetDocType";
import StepUnit from "./views/pages/InitialData/StepUnit";
import TbSetBank from "./views/pages/InitialData/TbSetBank";
import TbSetItmGroup from "./views/pages/InitialData/TbSetItmGroup";
import Service from "./views/pages/InitialData/Service";
import ServiceStep from "./views/pages/InitialData/ServiceStep";
import TimeUnit from "./views/pages/InitialData/TimeUnit";
import Package from "./views/pages/InitialData/Package";
import TbSetWH from "./views/pages/InitialData/TbSetWH";
import TbSetAP from "./views/pages/InitialData/TbSetAP/TbSetAP";
import Cover from "./views/pages/InitialData/Cover";
import TbSetColour from "./views/pages/InitialData/TbSetColour";
import TbSetSize from "./views/pages/InitialData/TbSetSize";
import TbSetServiceAddrType from "./views/pages/InitialData/TbSetServiceAddrType";
import TbSetServicePurpose from "./views/pages/InitialData/TbSetServicePurpose";
import ReleaseNotes from "./views/pages/InitialData/ReleaseNotes";
// 404
import NotFoundPage from "./views/pages/404";

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: { main: '#E13F57' },
    background: { default: '#F7F8FA', paper: '#FFFFFF' },
    text: { primary: '#111827', secondary: '#374151' },
  },
  components: {
    MuiButton: {
      styleOverrides: { root: { textTransform: 'none' } }
    },
  }
});

const root = ReactDOM.createRoot(document.getElementById("root"));
const isLoggedIn = localStorage.getItem("token");

root.render(
  <ThemeProvider theme={theme}>
    <CssBaseline />
    <BrowserRouter>
      <ToastContainer position="top-right" />

      <Routes>
        {/* จัดซื้อสินค้า */}
        <Route
          path="/"
          element={isLoggedIn ? <Home /> : <Navigate to="/login" />}
        />
        <Route
          path="/purchase-order"
          element={isLoggedIn ? <PurchaseOrder /> : <Navigate to="/login" />}
        />
        <Route
          path="/product-receipt"
          element={isLoggedIn ? <ProductReceipt /> : <Navigate to="/login" />}
        />
        <Route
          path="/payment-voucher"
          element={isLoggedIn ? <PaymentVoucher /> : <Navigate to="/login" />}
        />
        <Route
          path="/tax"
          element={isLoggedIn ? <Tax /> : <Navigate to="/login" />}
        />

        {/* คลังสินค้า */}
        <Route
          path="/withdraw-approval"
          element={isLoggedIn ? <WithdrawApprovalPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/warehouse"
          element={isLoggedIn ? <Warehouse /> : <Navigate to="/login" />}
        />
        <Route
          path="/warehouse-stock"
          element={isLoggedIn ? <WarehouseStock /> : <Navigate to="/login" />}
        />
        <Route
          path="/treasury-documents"
          element={isLoggedIn ? <TreasuryDocuments /> : <Navigate to="/login" />}
        />

        {/* สต๊อกสินค้า - routes ตาม foodorder */}
        <Route
          path="/stock"
          element={isLoggedIn ? <Navigate to="/stock/stock-overview" replace /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-overview"
          element={isLoggedIn ? <StockOverviewPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-documents"
          element={isLoggedIn ? <StockDocumentsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-management"
          element={isLoggedIn ? <StockManagementPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-detail"
          element={isLoggedIn ? <StockDetailPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-form-adjust"
          element={isLoggedIn ? <StockFormAdjustPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-form-transfer"
          element={isLoggedIn ? <StockFormTransferPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/stock/stock-form-count"
          element={isLoggedIn ? <StockFormCountPage /> : <Navigate to="/login" />}
        />

        {/* ระบบการขาย */}
        <Route
          path="/Sale"
          element={isLoggedIn ? <Sale /> : <Navigate to="/login" />}
        />
        <Route
          path="/EditCustomer/:id"
          element={isLoggedIn ? <EditCustomer /> : <Navigate to="/login" />}
        />
        <Route
          path="/history/:id"
          element={isLoggedIn ? <History /> : <Navigate to="/login" />}
        />
        <Route
          path="/quote/create/:AR_Id"
          element={isLoggedIn ? <Quote mode="create" /> : <Navigate to="/login" />}
        />
        <Route
          path="/quote/edit/:Doc_Id"
          element={isLoggedIn ? <Quote mode="edit" /> : <Navigate to="/login" />}
        />
        <Route
          path="/quotelist/:id"
          element={isLoggedIn ? <QuoteList /> : <Navigate to="/login" />}
        />

        {/* สัญญา */}

        <Route
          path="/contractlist/:id?"
          element={isLoggedIn ? <ContractList /> : <Navigate to="/login" />}
        />

        {/* ใบเสนอราคา admin */}
        <Route
          path="/admin-quotelist"
          element={isLoggedIn ? <AdminQuoteList /> : <Navigate to="/login" />}
        />
        <Route
          path="/admin/quote/create"
          element={isLoggedIn ? <AdminQuote /> : <Navigate to="/login" />}
        />
        <Route
          path="/contract/create/"
          element={isLoggedIn ? <Contract mode="create" /> : <Navigate to="/login" />}
        />
        <Route
          path="/contract/edit/:Contract_Id"
          element={isLoggedIn ? <Contract mode="edit" /> : <Navigate to="/login" />}
        />
        <Route
          path="/contract/view/:Contract_Id"
          element={isLoggedIn ? <Contract mode="view" /> : <Navigate to="/login" />}
        />

        <Route
          path="/contract-sign/:id"
          element={isLoggedIn ? <ContractSignPage /> : <Navigate to="/login" />}
        />

        <Route
          path="/jobfile"
          element={isLoggedIn ? <JobFilePage /> : <Navigate to="/login" />}
        />
        <Route
          path="/jobfile/:contractNo"
          element={isLoggedIn ? <JobFileDetailPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/jobfile/:id/invoice"
          element={isLoggedIn ? <JobFileInvoicePage /> : <Navigate to="/login" />}
        />
        <Route
          path="/jobfile/:id/invoice-record"
          element={isLoggedIn ? <JobFileInvoiceRecordPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/jobfile/:id/jobs"
          element={isLoggedIn ? <JobFileJobsPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/job-management"
          element={isLoggedIn ? <JobManagementPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/job/calendar"
          element={isLoggedIn ? <JobCalendarPageStandalone /> : <Navigate to="/login" />}
        />
        <Route
          path="/job/list"
          element={isLoggedIn ? <JobListPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/job/close/:id"
          element={isLoggedIn ? <JobServiceClosePage /> : <Navigate to="/login" />}
        />
        {/* Public feedback page — no auth required */}
        <Route path="/feedback" element={<FeedbackPage />} />
        <Route path="/feedback/:token" element={<FeedbackPage />} />
        <Route
          path="/invoice-record"
          element={isLoggedIn ? <JobFileInvoiceRecordListPage /> : <Navigate to="/login" />}
        />
        <Route
          path="/temp-equipment"
          element={isLoggedIn ? <TempEquipmentListPage /> : <Navigate to="/login" />}
        />



        {/* ข้อมูลตั้งต้น */}
        <Route
          path="/employee"
          element={isLoggedIn ? <Employee /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetitem"
          element={isLoggedIn ? <TbSetItem /> : <Navigate to="/login" />}
        />
        <Route
          path="/warehouse-item"
          element={isLoggedIn ? <WarehouseItem /> : <Navigate to="/login" />}
        />
        {/* ข้อมูลตั้งต้น ใหม่ */}
        <Route
          path="/company"
          element={isLoggedIn ? <Company /> : <Navigate to="/login" />}
        />
        <Route
          path="/org-access"
          element={isLoggedIn ? <OrgAccessAdminPage key="branches" /> : <Navigate to="/login" />}
        />
        <Route
          path="/org-roles"
          element={isLoggedIn ? <OrgAccessAdminPage key="roles" mode="roles" /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-call-report"
          element={isLoggedIn ? <SaleCallReport /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-report"
          element={isLoggedIn ? <SaleReport /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-call-detail/:Emp_Id"
          element={isLoggedIn ? <SaleCallDetail /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-appoint-report"
          element={isLoggedIn ? <SaleAppointReport /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-appoint-detail/:Emp_Id"
          element={isLoggedIn ? <SaleAppointDetail /> : <Navigate to="/login" />}
        />
        <Route
          path="/sale-customer-calendar"
          element={isLoggedIn ? <SaleCustomerCalendar /> : <Navigate to="/login" />}
        />
        <Route
          path="/transType"
          element={isLoggedIn ? <TbSetTransType /> : <Navigate to="/login" />}
        />
        <Route
          path="/docType"
          element={isLoggedIn ? <TbSetDocType /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetbank"
          element={isLoggedIn ? <TbSetBank /> : <Navigate to="/login" />}
        />
        <Route
          path="/serviceaddrtype"
          element={isLoggedIn ? <TbSetServiceAddrType /> : <Navigate to="/login" />}
        />
        <Route
          path="/servicepurpose"
          element={isLoggedIn ? <TbSetServicePurpose /> : <Navigate to="/login" />}
        />
        <Route
          path="/release-notes"
          element={isLoggedIn ? <ReleaseNotes /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetitmgroup"
          element={isLoggedIn ? <TbSetItmGroup /> : <Navigate to="/login" />}
        />
        <Route
          path="/service"
          element={isLoggedIn ? <Service /> : <Navigate to="/login" />}
        />
        <Route
          path="/servicestep"
          element={isLoggedIn ? <ServiceStep /> : <Navigate to="/login" />}
        />
        <Route
          path="/timeunit"
          element={isLoggedIn ? <TimeUnit /> : <Navigate to="/login" />}
        />
        <Route
          path="/stepunit"
          element={isLoggedIn ? <StepUnit /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetwh"
          element={isLoggedIn ? <TbSetWH /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetcolour"
          element={isLoggedIn ? <TbSetColour /> : <Navigate to="/login" />}
        />
        <Route
          path="/tbsetsize"
          element={isLoggedIn ? <TbSetSize /> : <Navigate to="/login" />}
        />
        <Route
          path="/creditor"
          element={isLoggedIn ? <TbSetAP /> : <Navigate to="/login" />}
        />
        <Route
          path="/package"
          element={isLoggedIn ? <Package /> : <Navigate to="/login" />}
        />
        <Route
          path="/team"
          element={isLoggedIn ? <Team /> : <Navigate to="/login" />}
        />
        <Route
          path="/cover"
          element={isLoggedIn ? <Cover /> : <Navigate to="/login" />}
        />

        {/* Login */}
        <Route path="/login" element={<Login />} />
        <Route path="*" element={<NotFoundPage />} />
      </Routes>
    </BrowserRouter>
  </ThemeProvider>
);
